import React from "react";

export default function CapsuleCard({ icon, name, profession, review }) {

    return (
        <div className="card capsule-card">
                <div className="card-img">
                    <img src={icon} alt={name} />
                </div>
                <p className="card-review">{review}</p>
                <h5 className="card-person">{name}</h5>
                <h6 className="card-profession">{profession}</h6>
        </div>
    );
}
